import { forwardRef } from 'react';

const BASE_TOOLTIP_ICON_STYLE = {
  width: '0.875rem',
  height: '0.875rem',
  cursor: 'help',
  flexShrink: 0,
};

function getTooltipIconStyle(withMargin = true) {
  return {
    ...BASE_TOOLTIP_ICON_STYLE,
    ...(withMargin ? { marginLeft: '0.375rem' } : null),
  };
}

function getTooltipIconClassName(baseClassName, className) {
  return [baseClassName, className].filter(Boolean).join(' ');
}

/**
 * InfoIcon - Minimal info icon for tooltips
 * Circle with lowercase "i"
 */
export const InfoIcon = forwardRef(function InfoIcon({ withMargin = true, className, ...props } = {}, ref) {
  return (
    <svg
      ref={ref}
      {...props}
      className={getTooltipIconClassName('ui-info-icon', className)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--text-muted)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={getTooltipIconStyle(withMargin)}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  );
});

/**
 * WarningIcon - Minimal warning icon for tooltip-only warnings
 * Triangle with alert mark
 */
export const WarningIcon = forwardRef(function WarningIcon({ withMargin = true, className, ...props } = {}, ref) {
  return (
    <svg
      ref={ref}
      {...props}
      className={getTooltipIconClassName('ui-warning-icon', className)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--status-warning, var(--color-amber-500))"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={getTooltipIconStyle(withMargin)}
    >
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
});
